interface CouncilPackProofProps {
  compact?: boolean;
}

export function CouncilPackProof({ compact = false }: CouncilPackProofProps) {
  return (
    <aside className="rounded-2xl border border-brand-200 bg-brand-50 p-5">
      <p className="font-display text-lg font-semibold text-brand-950">
        See the £35 Council Pack before you buy
      </p>
      {!compact && (
        <p className="mt-2 text-sm text-surface-700">
          Preview the claim letter, witness statement, schedule of facts, organised
          evidence and authority-name submission guidance using clearly redacted
          synthetic details.
        </p>
      )}
      <p className="mt-2 text-sm text-surface-700">
        One fixed price, no commission. The generated guidance names the authority and
        marks the witness statement and factual schedule as drafts. Review every fact,
        correct anything inaccurate and do not sign the Statement of Truth until every
        statement is accurate.
      </p>
      <a
        href="/sample-council-claim-pack"
        className="mt-3 inline-block font-semibold text-brand-700 underline"
      >
        View the synthetic sample
      </a>
    </aside>
  );
}
